// extracted by mini-css-extract-plugin
module.exports = {"container":"Damages_container__1K-10","page":"Damages_page__3fquI","section":"Damages_section__wUS2V"};